import { Avatar as AntAvatar, AvatarProps } from "antd";
import styled from "styled-components";

export const Avatar: typeof AntAvatar = styled(AntAvatar)<AvatarProps>``;
